export default __webpack_public_path__ + "static/media/illustration_key_visual.f53f7483.png";